import { observer } from 'mobx-react-lite';
import { PropsWithChildren, useMemo } from 'react';
import { useStore } from '../../stores/store';
import { ModalContext } from './modal-context';

const ModalProvider = ({ children }: PropsWithChildren) => {
  const {
    modalStore: {
      currentModal,
      open,
      enqueueNext,
      close,
      update,
      isModalVisible,
      isAnyModalOpened,
    },
  } = useStore();

  const value = useMemo(
    () => ({
      currentModal,
      openModal: open,
      enqueueModalNext: enqueueNext,
      closeModal: close,
      updateModal: update,
      isModalVisible,
      isAnyModalOpened,
    }),
    [
      currentModal,
      open,
      enqueueNext,
      update,
      close,
      isModalVisible,
      isAnyModalOpened,
    ]
  );

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export default observer(ModalProvider);
